/**
 * Logo VELORA JDM — componente riutilizzabile.
 *
 * Varianti:
 * - `horizontal` (default): logo largo con VELORA JDM su fascia rossa — per header/footer/landing.
 * - `horizontalAlt`: versione con auto stilizzata sotto (per hero/marketing).
 * - `square`: logo quadrato per avatar social / favicon / print.
 *
 * Uso:
 *   <Logo variant="horizontal" className="h-8" />
 *   <Logo variant="square" className="w-16 h-16" />
 */
export default function Logo({ variant = "horizontal", className = "", alt = "VELORA JDM Experience" }) {
    const map = {
        horizontal: "/logo/velora-horizontal.png",
        horizontalAlt: "/logo/velora-horizontal-alt.png",
        square: "/logo/velora-square.png",
    };
    const src = map[variant] || map.horizontal;
    return (
        <img
            src={src}
            alt={alt}
            className={`select-none ${className}`}
            draggable={false}
            data-testid={`logo-${variant}`}
        />
    );
}
